










import Header from '@/components/navBare.vue';
import SiteFooter from '@/components/footer.vue';

export default {
  components: {
    Header, SiteFooter,
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Hello',
    // all titles will be injected into this template
    titleTemplate: '%s | Interlab',

    htmlAttrs: {
      lang: navigator.language,
    },
  },
  name: 'App',
};
